import { Link as RouteDomLink, LinkProps } from 'react-router-dom';
import { usePathWithSpoof } from 'hooks/api';

type Props = Omit<LinkProps, 'to'> & { to: string };

export const Link = ({ to, ...props }: Props) => {
  const pathWithSpoof = usePathWithSpoof(to);
  return <RouteDomLink {...props} to={pathWithSpoof} />;
};
